/**
 * Fired when a surface outside the navigation wants the Quick DM panel open.
 * Keeps those callers from having to reach into the navigation's local state.
 */
export const OPEN_QUICK_DM_EVENT = 'kaos:open-quick-dm';
